<template>
	<feature-item :bordered="bordered" :divided="divided">

		<skeleton height="16" width="55" class="mb-10" rounded/>
		<skeleton height="12" width="200" class="mb-18" rounded/>

		<paragraph-skeleton small class="mb-0" :lines="5" :spacing="7"/>

		<template #image>
			<skeleton :height="imageSize" :width="imageSize" rounded>
			</skeleton>
		</template>

		<template #info>
			<slot name="info"/>
		</template>

		<template #actions>
			<slot name="actions"/>
		</template>

	</feature-item>
</template>

<script>
export default {
    name: "FeatureItemSkeleton",

    props: {

        // Whether the resource item shall get additional spacing and multiple items shall be
        // divided with a border
        divided: {
            type: Boolean,
            default: false
        },

        // Whether the resource item shall get a border style
        bordered: {
            type: Boolean,
            default: false
        },

    },

    computed: {
        imageSize() {
            return this.$breakpoint.xsOnly ? 80 : 112;
        }
    }

}
</script>